module.exports = __webpack_public_path__ + "img/memory_pc.1b7eb872.svg";